import React from 'react';
import './Button.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className = '',
      variant = 'primary',
      size = 'md',
      isLoading = false,
      fullWidth = false,
      leftIcon,
      rightIcon,
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    const baseClasses = 'qube-btn';
    const variantClasses = `qube-btn-${variant}`;
    const sizeClasses = `qube-btn-${size}`;
    const widthClass = fullWidth ? 'qube-btn-full' : '';
    const loadingClass = isLoading ? 'qube-btn-loading' : '';
    
    const combinedClasses = [
      baseClasses,
      variantClasses,
      sizeClasses,
      widthClass,
      loadingClass,
      className
    ].filter(Boolean).join(' ');

    return (
      <button
        ref={ref}
        className={combinedClasses}
        disabled={disabled || isLoading}
        {...props}
      >
        {isLoading && <span className="qube-btn-spinner" />}
        {!isLoading && leftIcon && <span className="qube-btn-icon-left">{leftIcon}</span>}
        <span className="qube-btn-content">{children}</span>
        {!isLoading && rightIcon && <span className="qube-btn-icon-right">{rightIcon}</span>}
      </button>
    );
  }
);

Button.displayName = 'Button';
